import type { Order } from '#domain/Order.ts';

export const sortOrderOptions = (orders: Order[], selectedOrderIds: string[]) =>
    [
        ...orders.filter(order => selectedOrderIds.includes(order.id)),
        ...orders.filter(order => !selectedOrderIds.includes(order.id)),
    ].map(order => ({
        id: order.id,
        label: order.number,
        selected: selectedOrderIds.includes(order.id),
    }));
